import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import {
  getAssistMigrationProfiles,
  GetAssistMigrationProfilesParams,
} from 'api/assist/migration/getAssistMigrationProfiles';
import { ApiError } from 'types/api';
import { AssistMigrationProfileListResult } from 'types/assist/assistMigration';

export const useAssistMigrationProfiles = (params: GetAssistMigrationProfilesParams) => {
  return useQuery<AssistMigrationProfileListResult, ApiError>({
    queryKey: ['assistMigrationProfiles', params],
    queryFn: async () => {
      const { data } = await getAssistMigrationProfiles(params);

      return data.data;
    },
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'Failed to load Assist migration profiles',
        { duration: 4000 },
      );
    },
  });
};
